(function() {
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form || !form.matches('form[action="/cart/add"], form[action*="/cart/add"]')) return;
    
    e.preventDefault();
    
    const btn = form.querySelector('[data-add-to-cart], button[type="submit"]');
    
    let textEl, loadingEl, successEl;
    if (btn) {
      textEl = btn.querySelector('.btn-text');
      loadingEl = btn.querySelector('.btn-loading');
      successEl = btn.querySelector('.btn-success');
      
      if (textEl) textEl.classList.add('hidden');
      if (loadingEl) loadingEl.classList.remove('hidden');
      btn.disabled = true;
      btn.style.opacity = '0.85';
    }
    
    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      
      if (!res.ok) {
        const error = await res.json();
        throw new Error(error.description || 'Failed to add to cart');
      }
      
      if (btn) {
        if (loadingEl) loadingEl.classList.add('hidden');
        if (successEl) {
          successEl.classList.remove('hidden');
          successEl.classList.add('btn-success-pop');
        }
      }
      
      document.dispatchEvent(new CustomEvent('cart:added'));
      
      setTimeout(() => {
        if (btn) {
          if (successEl) {
            successEl.classList.add('hidden');
            successEl.classList.remove('btn-success-pop');
          }
          if (textEl) textEl.classList.remove('hidden');
          btn.disabled = false;
          btn.style.opacity = '';
        }
      }, 1500);
      
    } catch (err) {
      console.error('Add to cart failed:', err);
      if (btn) {
        if (loadingEl) loadingEl.classList.add('hidden');
        if (textEl) textEl.classList.remove('hidden');
        btn.disabled = false;
        btn.style.opacity = '';
      }
      alert(err.message || 'Could not add to cart. Please try again.');
    }
  });
})();